import './elements/CommunicatorSidebar';
import './components/views/ThreadView';
import './components/views/ThreadEventsOnlyView';
import {throttle} from 'imatic/vsem-design/assets/util/Animation';

{
    const layout = document.querySelector('body');

    if (layout) {
        window.addEventListener('resize', throttle((e) => {
            const windowHeight = window.innerHeight || document.documentElement.clientHeight;

            layout.setAttribute('style', `height: ${windowHeight}px;`);
        }));
    }
}
$(document).ready(function() {
    $('select.select2').select2();
});
